










































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgEventEdit from '@/modules/events/_components/DlgEventEdit.vue';
import DlgEventDelete from '@/modules/events/_components/DlgEventDelete.vue';

@Component({
  components: {
    Card,
    DlgEventEdit,
    DlgEventDelete,
  },
})
export default class EventsList extends Vue {
  private loading: boolean = false;
  private currentEvent: any = {};
  private dlgEdit: boolean = false;

  // the getter already returns upcoming events first, then past ones - keep that order
  private headers: any = [
    { text: 'Datum', align: 'left', sortable: false, value: 'date' },
    { text: 'Uhrzeit', align: 'left', sortable: false, value: 'time' },
    { text: 'Ort', align: 'left', sortable: false, value: 'venue' },
    { text: 'Hinweis', align: 'left', sortable: false, value: 'note' },
    { text: 'Aktiv', align: 'left', sortable: false, value: 'active' },
    { text: '', align: 'left', sortable: false, value: '' },
  ];

  private pagination: any = {
    page: 1,
    rowsPerPage: -1,
    sortBy: null,
  };

  private search: string = '';

  @Getter('events/all') private events!: any[];
  @Getter('members/all') private members!: any[];
  @Action('events/read') private readAllEvents!: any;
  @Action('members/read') private readMembers!: any;

  private created() {
    this.loading = true;
    this.readAllEvents()
      .then(() => {
        this.loading = false;
      });
    if (!this.members || !this.members.length) {
      this.readMembers();
    }
  }

  private memberTitle(slug: string) {
    const member = (this.members || []).find((m: any) => m.slug === slug);
    return member ? member.title : slug;
  }

  private create() {
    this.currentEvent = {};
    this.dlgEdit = true;
  }

  private edit(event: any) {
    this.currentEvent = event;
    this.dlgEdit = true;
  }
}
